import { useLocation } from 'react-router-dom'

export function useIsWrapPage() {
  const { pathname } = useLocation()
  return pathname.startsWith('/wrap')
}
